import React from "react";
import { GamificationTier } from "../context/NespressoContext";

// Tier badge icons
const TIER_ICONS: Record<string, string> = {
  "first-sip": "☕",
  "espresso-explorer": "🌱",
  "lungo-legend": "🏆",
  "barista-bronze": "🥉",
  "crema-connoisseur": "⭐",
  "master-roaster": "🔥",
  "grand-cru-guardian": "👑",
};

export interface TierBadgeProps {
  tier: GamificationTier;
  size?: "sm" | "md" | "lg";
  showName?: boolean;
}

const TierBadge: React.FC<TierBadgeProps> = ({
  tier,
  size = "md",
  showName = false,
}) => {
  const sizeClasses = {
    sm: "w-6 h-6 text-sm",
    md: "w-8 h-8 text-lg",
    lg: "w-12 h-12 text-2xl",
  };

  const icon = TIER_ICONS[tier.id] || "🏆";

  return (
    <div className="flex items-center gap-2">
      <div
        className={`${sizeClasses[size]} rounded-full flex items-center justify-center`}
        style={{
          background: `linear-gradient(135deg, ${tier.badge.color} 0%, ${tier.badge.color}99 100%)`,
          boxShadow: `0 2px 8px ${tier.badge.color}40`,
        }}
        title={tier.name}
      >
        <span role="img" aria-label={tier.name}>
          {icon}
        </span>
      </div>
      {showName && (
        <span
          className="text-sm font-medium"
          style={{ color: tier.badge.color }}
        >
          {tier.name}
        </span>
      )}
    </div>
  );
};

export default TierBadge;
